import { render, staticRenderFns } from "./DownloadTipDialog.vue?vue&type=template&id=0c79dd08&scoped=true"
import script from "./DownloadTipDialog.vue?vue&type=script&lang=ts"
export * from "./DownloadTipDialog.vue?vue&type=script&lang=ts"
import style0 from "./DownloadTipDialog.vue?vue&type=style&index=0&id=0c79dd08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c79dd08",
  null
  
)

export default component.exports